import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import {
  DownloadCategory,
  DownloadCloud,
  type DownloadRow,
  DownloadStatus,
  OutputFormat,
} from "./download";

/** Client-facing shape of a download (no account id, bigint counts → number). */
const DownloadDtoSchema_ = z.object({
  id: z.string(),
  reportType: z.string(),
  cloud: createEnum(DownloadCloud, { enumName: "DownloadCloud" }),
  category: createEnum(DownloadCategory, {
    enumName: "DownloadCategory",
  }).nullable(),
  status: createEnum(DownloadStatus, { enumName: "DownloadStatus" }),
  format: createEnum(OutputFormat, { enumName: "OutputFormat" }),
  displayName: z.string(),
  fileSizeBytes: z.number().nullable(),
  rowsProcessed: z.number().nullable(),
  totalRows: z.number().nullable(),
  error: z.string().nullable(),
  createdAt: z.date(),
  startedAt: z.date().nullable(),
  completedAt: z.date().nullable(),
  expiresAt: z.date(),
});
export const DownloadDtoSchema: z.ZodType<DownloadDto> = DownloadDtoSchema_;
export interface DownloadDto extends z.infer<typeof DownloadDtoSchema_> {}

export function toDownloadDto(row: DownloadRow): DownloadDto {
  return {
    id: row.id,
    reportType: row.reportType,
    cloud: row.cloud,
    category: row.category,
    status: row.status,
    format: row.format,
    displayName: row.displayName,
    fileSizeBytes: row.fileSizeBytes == null ? null : Number(row.fileSizeBytes),
    rowsProcessed: row.rowsProcessed == null ? null : Number(row.rowsProcessed),
    totalRows: row.totalRows == null ? null : Number(row.totalRows),
    error: row.error,
    createdAt: row.createdAt,
    startedAt: row.startedAt,
    completedAt: row.completedAt,
    expiresAt: row.expiresAt,
  };
}
